// import React, { useState } from "react";
// import {
//   Button,
//   Dialog,
//   DialogContent,
//   DialogTitle,
//   ThemeProvider,
//   Typography,
//   createTheme,
//   Box,
//   useMediaQuery,
// } from "@mui/material";

// const darkTheme = createTheme({
//   palette: {
//     mode: "dark",
//   },
// });

// const StartGuideDialog = ({ startGuide }) => {
//   const [open, setOpen] = useState(true);
//   const isPhone = useMediaQuery("(max-width:600px)");
//   const isLandscape = useMediaQuery("(orientation: landscape)");
//   const dialogWidth = isPhone
//     ? isLandscape
//       ? "76vw"
//       : "92vw"
//     : "400px";
//   const dialogMargin = isPhone ? "12px auto" : "150px";

//   // Function to request microphone access
//   const handleStartGuide = async () => {
//     try {
//       startGuide && startGuide();
//       setOpen(false);
//     } catch (error) {
//       console.error("Error starting guide:", error);
//     }
//   };

//   return (
//     <ThemeProvider theme={darkTheme}>
//       <Dialog
//         open={open}
//         fullWidth
//         maxWidth="sm"
//         sx={{
//           "& .MuiDialog-container": {
//             alignItems: isPhone && isLandscape ? "flex-start" : "center", // keep dialog visible in landscape
//             padding: isPhone ? "12px" : undefined, // keep desktop default spacing
//           },
//         }}
//         PaperProps={{
//           sx: isPhone
//             ? {
//                 width: dialogWidth,
//                 maxWidth: dialogWidth,
//                 margin: dialogMargin,
//                 borderRadius: 2,
//                 px: "var(--dialog-padding, 24px)",
//                 py: 2,
//               }
//             : {
//                 width: "400px",
//                 maxWidth: "400px",
//                 margin: "150px",
//               },
//         }}
//       >
//         <DialogTitle>Ready to start?</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Begin your experience - make sure to turn up your audio to hear the Guide. To navigate, zoom in and out using your scroll wheel or trackpad.
//           </Typography>
//           <Box mt={2}>
//             <Button
//               variant="contained"
//               color="secondary"
//               onClick={handleStartGuide}
//             >
//               Start Guide
//             </Button>
//           </Box>
//         </DialogContent>
//       </Dialog>

     
//     </ThemeProvider>
//   );
// };

// export default StartGuideDialog;

import React, { useRef, useEffect } from "react";
import { Box, useMediaQuery } from "@mui/material";

// ============================================
// IDLE ORB — DEFAULT state, self-contained
// ============================================

const SPHERE_DEFAULT_HEX = "#5377E0";

const hexToRgb = (hex) => ({
  r: parseInt(hex.slice(1, 3), 16),
  g: parseInt(hex.slice(3, 5), 16),
  b: parseInt(hex.slice(5, 7), 16),
});

const IdleOrb = ({ size = 110 }) => {
  const canvasRef = useRef(null);
  const rafRef = useRef(null);
  const dataRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const S = size;
    const C = S / 2;
    const dpr = window.devicePixelRatio || 1;
    canvas.width = S * dpr;
    canvas.height = S * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const max = 80;
    const basePoints = [];
    let r = 0;
    for (let a = 0; a < max; a++) {
      basePoints.push([Math.cos(r), Math.sin(r), 0]);
      r += (Math.PI * 2) / max;
    }
    for (let a = 0; a < max; a++) basePoints.push([0, basePoints[a][0], basePoints[a][1]]);
    for (let a = 0; a < max; a++) basePoints.push([basePoints[a][1], 0, basePoints[a][0]]);

    const rgb = hexToRgb(SPHERE_DEFAULT_HEX);
    dataRef.current = { count: 0, curR: rgb.r, curG: rgb.g, curB: rgb.b };

    const draw = () => {
      const d = dataRef.current;
      const scalePulse = 1.0 + Math.sin(d.count * 0.055) * 0.018;

      ctx.globalCompositeOperation = "destination-out";
      ctx.filter = "blur(18px)";
      ctx.fillStyle = "rgba(0,0,0,0.05)";
      ctx.fillRect(0, 0, S, S);
      ctx.filter = "none";
      ctx.globalCompositeOperation = "lighter";

      let tim = d.count / 5;
      for (let e = 0; e < 3; e++) {
        tim *= 1.7;
        let s = 1 - e / 3;
        let a = (tim * 0.75) / 59;
        const yp = Math.cos(a), yp2 = Math.sin(a);
        a = (tim * 0.75) / 23;
        const xp = Math.cos(a), xp2 = Math.sin(a);

        const p2 = [];
        for (let i = 0; i < basePoints.length; i++) {
          const [x, y, z] = basePoints[i];
          const y1 = y * yp + z * yp2;
          const z1 = y * yp2 - z * yp;
          const x1 = x * xp + z1 * xp2;
          const zz = x * xp2 - z1 * xp;
          const z2 = Math.pow(2, zz * s);
          p2.push([x1 * z2, y1 * z2, zz]);
        }

        s *= C * 0.62 * scalePulse;
        for (let dd = 0; dd < 3; dd++) {
          for (let i = 0; i < max; i++) {
            const b = p2[dd * max + i];
            const c2 = p2[((i + 1) % max) + dd * max];
            const brightness = 0.65 + 0.35 * Math.sin((i / max) * Math.PI * 2);
            ctx.beginPath();
            ctx.strokeStyle = `rgba(${Math.round(d.curR * brightness)},${Math.round(d.curG * brightness)},${Math.round(d.curB * brightness)},0.25)`;
            ctx.lineWidth = Math.pow(6, b[2]);
            ctx.moveTo(b[0] * s + C, b[1] * s + C);
            ctx.lineTo(c2[0] * s + C, c2[1] * s + C);
            ctx.stroke();
          }
        }
      }

      d.count += 1;
      rafRef.current = requestAnimationFrame(draw);
    };

    rafRef.current = requestAnimationFrame(draw);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [size]);

  return <canvas ref={canvasRef} style={{ width: size, height: size, display: "block" }} />;
};

// ============================================
// FOUR OUTWARD ARROWS ICON
// Suggests free movement in all directions
// ============================================

const FreeExploreIcon = ({ size = 52 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Up arrow */}
    <path
      d="M26 18 L26 8 M26 8 L21 13 M26 8 L31 13"
      stroke="rgba(255,255,255,0.75)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Down arrow */}
    <path
      d="M26 34 L26 44 M26 44 L21 39 M26 44 L31 39"
      stroke="rgba(255,255,255,0.75)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Left arrow */}
    <path
      d="M18 26 L8 26 M8 26 L13 21 M8 26 L13 31"
      stroke="rgba(255,255,255,0.75)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Right arrow */}
    <path
      d="M34 26 L44 26 M44 26 L39 21 M44 26 L39 31"
      stroke="rgba(255,255,255,0.75)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Center dot */}
    <circle cx="26" cy="26" r="2.5" fill="rgba(255,255,255,0.55)" />
  </svg>
);

// ============================================
// DIALOG
// ============================================

const StartGuideDialog = ({ onStartGuide, onSkip }) => {
  const isPhone = useMediaQuery("(max-width:600px)");
  const rgb = hexToRgb(SPHERE_DEFAULT_HEX);
  const guidedGlow = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.35)`;
  const buttonSize = isPhone ? 122 : 138;
  const iconSize = isPhone ? 46 : 52;

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(4, 6, 14, 0.72)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        px: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: isPhone ? 1.25 : 1.5,
          animation: "selectorIn 0.25s ease",
          "@keyframes selectorIn": {
            "0%":   { opacity: 0, transform: "scale(0.92) translateY(12px)" },
            "100%": { opacity: 1, transform: "scale(1) translateY(0)"       },
          },
        }}
      >
        {/* Free Explore card */}
        <Box
          component="button"
          onClick={onSkip}
          sx={{
            width: buttonSize,
            height: buttonSize,
            borderRadius: "16px",
            border: "1px solid rgba(255,255,255,0.14)",
            background: "rgba(8, 12, 22, 0.76)",
            color: "rgba(255,255,255,0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.75,
            cursor: "pointer",
            fontFamily: "inherit",
            transition: "transform 0.15s ease, background 0.15s ease, border-color 0.15s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              background: "rgba(14, 19, 33, 0.84)",
              borderColor: "rgba(255,255,255,0.24)",
            },
            "&:active": { transform: "scale(0.98)" },
          }}
        >
          <FreeExploreIcon size={iconSize} />
          <Box sx={{ fontSize: isPhone ? "0.8rem" : "0.85rem", fontWeight: 600 }}>
            Free explore
          </Box>
        </Box>

        {/* Guided card */}
        <Box
          component="button"
          onClick={onStartGuide}
          sx={{
            width: buttonSize,
            height: buttonSize,
            borderRadius: "16px",
            border: `1px solid rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.5)`,
            background: `linear-gradient(160deg, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.34), rgba(10, 14, 28, 0.92))`,
            boxShadow: `0 10px 28px ${guidedGlow}`,
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 0.6,
            cursor: "pointer",
            fontFamily: "inherit",
            transition: "transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: `0 14px 32px rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.42)`,
              borderColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.72)`,
            },
            "&:active": { transform: "scale(0.98)" },
          }}
        >
          <Box sx={{ opacity: 0.95, transform: "translateY(-1px)" }}>
            <IdleOrb size={iconSize} />
          </Box>
          <Box sx={{ fontSize: isPhone ? "0.8rem" : "0.85rem", fontWeight: 700 }}>
            Guided
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StartGuideDialog;